module.exports = __webpack_public_path__ + "img/label_mini_bg.a78dbb67.png";